// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentCardSkeleton-paymentCardSkeletonBox-Ccnk_ {
    padding: 24px;
    background-color: var(--background-secondary);
    border-radius: var(--radius-3);
}

.PaymentCardSkeleton-paymentCardTabSkeletonContainer-i70JN,
.PaymentCardSkeleton-paymentCardTabSkeletonWrapper-i38Gs {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 12px 18px;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    width: 100%;
}

.PaymentCardSkeleton-paymentCardTabSkeletonContainer-i70JN {
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    margin-bottom: 18px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.PaymentCardSkeleton-paymentCardTabSkeleton-umuI8 {
    border-radius: var(--radius-rounded);
    max-width: 165px;
    height: 48px;
    background-color: var(--skeleton-secondary-bg);
}

.PaymentCardSkeleton-paymentCardLabelSkeleton-wvYlt {
    max-width: 100%;
    height: 26px;
    background-color: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
    margin-bottom: 6px;
}

.PaymentCardSkeleton-paymentCardLabelSkeleton1-Dx8Tv {
    max-width: 61px;
}

.PaymentCardSkeleton-paymentCardLabelSkeleton2-FEt2G {
    max-width: 132px;
}

.PaymentCardSkeleton-paymentCardInputSkeleton-cYwqC {
    max-width: 100%;
    height: 44px;
    background-color: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

.PaymentCardSkeleton-paymentCardBtn-vtwJu {
    height: 44px;
    background-color: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

.PaymentCardSkeleton-paymentCardBackBtn-HzZkV {
    max-width: 93px;
}

.PaymentCardSkeleton-paymentCardSaveBtn-BOgle {
    max-width: 72px;
}

@media (max-width:767px) {
    .PaymentCardSkeleton-paymentCardTabSkeletonContainer-i70JN {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
    }

    .PaymentCardSkeleton-paymentCardTabSkeletonWrapper-i38Gs {
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
    }
}

@media (max-width: 480px) {
    .PaymentCardSkeleton-paymentCardSkeletonBox-Ccnk_ {
        padding: 18px 12px;
    }

    .PaymentCardSkeleton-paymentCardTabSkeletonWrapper-i38Gs {
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        width: 100%;
    }

    .PaymentCardSkeleton-paymentCardTabSkeleton-umuI8 {
        max-width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/ViewBooking/PaymentCardSkeleton/PaymentCardSkeleton.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,6CAA6C;IAC7C,8BAA8B;AAClC;;AAEA;;IAEI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,cAAc;IACd,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,8CAA8C;IAC9C,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,8CAA8C;IAC9C,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,8CAA8C;IAC9C,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;IAC1B;;IAEA;QACI,mBAAe;YAAf,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAY;YAAZ,oBAAY;gBAAZ,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".paymentCardSkeletonBox {\n    padding: 24px;\n    background-color: var(--background-secondary);\n    border-radius: var(--radius-3);\n}\n\n.paymentCardTabSkeletonContainer,\n.paymentCardTabSkeletonWrapper {\n    display: flex;\n    gap: 12px 18px;\n    align-items: flex-start;\n    width: 100%;\n}\n\n.paymentCardTabSkeletonContainer {\n    justify-content: space-between;\n    margin-bottom: 18px;\n    flex-wrap: wrap;\n}\n\n.paymentCardTabSkeleton {\n    border-radius: var(--radius-rounded);\n    max-width: 165px;\n    height: 48px;\n    background-color: var(--skeleton-secondary-bg);\n}\n\n.paymentCardLabelSkeleton {\n    max-width: 100%;\n    height: 26px;\n    background-color: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n    margin-bottom: 6px;\n}\n\n.paymentCardLabelSkeleton1 {\n    max-width: 61px;\n}\n\n.paymentCardLabelSkeleton2 {\n    max-width: 132px;\n}\n\n.paymentCardInputSkeleton {\n    max-width: 100%;\n    height: 44px;\n    background-color: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.paymentCardBtn {\n    height: 44px;\n    background-color: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.paymentCardBackBtn {\n    max-width: 93px;\n}\n\n.paymentCardSaveBtn {\n    max-width: 72px;\n}\n\n@media (max-width:767px) {\n    .paymentCardTabSkeletonContainer {\n        flex-direction: column;\n    }\n\n    .paymentCardTabSkeletonWrapper {\n        flex-wrap: wrap;\n    }\n}\n\n@media (max-width: 480px) {\n    .paymentCardSkeletonBox {\n        padding: 18px 12px;\n    }\n\n    .paymentCardTabSkeletonWrapper {\n        flex-grow: 1;\n        width: 100%;\n    }\n\n    .paymentCardTabSkeleton {\n        max-width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentCardSkeletonBox": `PaymentCardSkeleton-paymentCardSkeletonBox-Ccnk_`,
	"paymentCardTabSkeletonContainer": `PaymentCardSkeleton-paymentCardTabSkeletonContainer-i70JN`,
	"paymentCardTabSkeletonWrapper": `PaymentCardSkeleton-paymentCardTabSkeletonWrapper-i38Gs`,
	"paymentCardTabSkeleton": `PaymentCardSkeleton-paymentCardTabSkeleton-umuI8`,
	"paymentCardLabelSkeleton": `PaymentCardSkeleton-paymentCardLabelSkeleton-wvYlt`,
	"paymentCardLabelSkeleton1": `PaymentCardSkeleton-paymentCardLabelSkeleton1-Dx8Tv`,
	"paymentCardLabelSkeleton2": `PaymentCardSkeleton-paymentCardLabelSkeleton2-FEt2G`,
	"paymentCardInputSkeleton": `PaymentCardSkeleton-paymentCardInputSkeleton-cYwqC`,
	"paymentCardBtn": `PaymentCardSkeleton-paymentCardBtn-vtwJu`,
	"paymentCardBackBtn": `PaymentCardSkeleton-paymentCardBackBtn-HzZkV`,
	"paymentCardSaveBtn": `PaymentCardSkeleton-paymentCardSaveBtn-BOgle`
};
module.exports = ___CSS_LOADER_EXPORT___;
